export const USER_POWER_LEVEL: UserPermissionPower = {
  [UserPermission.READ_ONLY]: UserPermissionLevel.READ_ONLY,
  [UserPermission.MAINTAINER]: UserPermissionLevel.MAINTAINER,
  [UserPermission.ADMIN]: UserPermissionLevel.ADMIN,
  [UserPermission.OWNER]: UserPermissionLevel.OWNER
}
